var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "image-picker" }, [
    _c(
      "div",
      { staticClass: "image-list" },
      [
        _vm._l(_vm.images, function (item, index) {
          return _c(
            "div",
            {
              key: item.id,
              staticClass: "image-item",
              on: {
                click: function ($event) {
                  return _vm.previewImage(index)
                },
              },
            },
            [
              _c("img", {
                staticClass: "image",
                attrs: { src: item.url, alt: "" },
              }),
              _c(
                "div",
                {
                  staticClass: "delete-button",
                  on: {
                    click: function ($event) {
                      $event.stopPropagation()
                      return _vm.removeImage(index)
                    },
                  },
                },
                [_vm._v(" × ")]
              ),
            ]
          )
        }),
        _vm.images.length < _vm.maxCount
          ? _c(
              "div",
              { staticClass: "image-add", on: { click: _vm.chooseImages } },
              [
                _c("i", { staticClass: "el-icon-plus" }),
                _c("span", [_vm._v(" 添加图片 ")]),
              ]
            )
          : _vm._e(),
      ],
      2
    ),
    _c("div", { staticClass: "image-tip" }, [
      _vm._v(" " + _vm._s(_vm.tip) + " "),
    ]),
    _c("input", {
      ref: "fileInput",
      staticClass: "hidden-input",
      attrs: { type: "file", accept: "image/*", multiple: "" },
      on: { change: _vm.handleFileChange },
    }),
    _vm.previewVisible
      ? _c(
          "div",
          { staticClass: "preview-mask", on: { click: _vm.closePreview } },
          [
            _c(
              "div",
              {
                staticClass: "preview-close",
                on: {
                  click: function ($event) {
                    $event.stopPropagation()
                    return _vm.closePreview($event)
                  },
                },
              },
              [_vm._v(" × ")]
            ),
            _vm.images.length > 1
              ? _c(
                  "div",
                  {
                    staticClass: "preview-prev",
                    on: {
                      click: function ($event) {
                        $event.stopPropagation()
                        return _vm.previewPrev($event)
                      },
                    },
                  },
                  [_vm._v(" ‹ ")]
                )
              : _vm._e(),
            _vm.currentPreview
              ? _c("img", {
                  staticClass: "preview-image",
                  attrs: { src: _vm.currentPreview.url, alt: "" },
                  on: {
                    click: function ($event) {
                      $event.stopPropagation()
                    },
                  },
                })
              : _vm._e(),
            _vm.images.length > 1
              ? _c(
                  "div",
                  {
                    staticClass: "preview-next",
                    on: {
                      click: function ($event) {
                        $event.stopPropagation()
                        return _vm.previewNext($event)
                      },
                    },
                  },
                  [_vm._v(" › ")]
                )
              : _vm._e(),
            _c("div", { staticClass: "preview-index" }, [
              _vm._v(
                " " +
                  _vm._s(_vm.previewIndex + 1) +
                  " / " +
                  _vm._s(_vm.images.length) +
                  " "
              ),
            ]),
          ]
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }